import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-slide-show-image-block',
  templateUrl: './slide-show-image-block.component.html',
})
export class SlideShowImageBlockComponent {
  @Input() title?: string;
  @Input() anchor?: string;
  @Input() images: unknown[] = [];
}
